import * as React from 'react';
import { useTranslation } from 'react-i18next';

const fields = (expertise) => {
  return {
    config: { columns: 1 },
    fields: [
      {
        name: 'toolType',
        label: 'formConfig.toolType',
        column: 1,
        type: 'enum',
        enumType: 'enums/toolType',
        mandatory: true,
      },
      {
        name: 'tool',
        label: 'formConfig.tool',
        column: 1,
        type: 'dictionary',
        withAutocomplete: true,
        dictionary: 'tools',
        mandatory: true,
        conditionalOn: 'toolType',
        conditionalOnNotNull: true,
        filterValues: function (dictionaries, formData, values) {
          if (formData && formData['toolType']) {
            return values
              .filter((t) =>
                expertise ? t.verified && !t.expertiseVerified : !t.verified
              )
              .filter((t) => t.toolType === formData['toolType']);
          }

          return values.filter((t) => !t.verified);
        },
      },
    ],
  };
};

export default fields;
